<!--
 * @Description:
 * @Date: 2020-09-05 15:15:14
-->

<script>
export default {
  props: {
    title: {
      type: String,
      default: '相关文件'
    },
    type: {
      type: String,
      default: 'left-line',
      validator(v) {
        return ['left-line', 'bottom-line'].includes(v);
      }
    }
  },
  render(h) {
    return h('div', { class: [this.type, 'default', 'xrk-subtitle'] }, [
      h('span', this.$slots.default || this.title),
      this.$slots.right
    ]);
  }
};
</script>

<style scoped lang="scss">
@import '@/styles/theme.scss';
@import '~@/styles/mixin.scss';
.xrk-subtitle {
  margin: 20px;
}
.default {
  position: relative;
  text-align: left;
}
.bottom-line {
  border-bottom: 2px solid $--color-primary;
  span {
    display: inline-block;
    background: $--color-primary;
    padding: 5px 16px;
    color: #fff;
    font-size: 14px;
    border-radius: 6px 6px 0px 0px;
  }
}
.left-line {
  font-size: 20px;
  font-weight: 500;
  padding-left: 16px;
  position: relative;
  line-height: 1;
  &::before {
    content: ' ';
    width: 8px;
    height: 24px;
    background: $--color-primary;
    @include absolute_mid('y');
    left: 0;
  }
}
</style>
